<form *ngIf="addRoleForm && validation" [ngClass]="{'invalid-submit': invalidSubmit}" [formGroup]="addRoleForm" (ngSubmit)="addRole()" RestrictFocus>
    <div class="ui-grid ui-grid-responsive ui-fluid">
        <div class="ui-grid-row">
            <div class="ui-grid-col-4"><label [ngClass]="{'required': !validation.descr.nullable}">{{ validation.descr.keyName }}</label></div>
            <div class="ui-grid-col-8">
              <input formControlName="descr" type="text" pInputText/>
              <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [(form)]="addRoleForm" [validation]="validation.descr"></app-validation-msg>
            </div>
        </div>
        <div class="ui-grid-row bottom-10-margin">
        </div>
        <div class="ui-grid-row" *ngIf="showdropdown">
            <div class="ui-grid-col-4"><label [ngClass]="{'required': !validation.type.nullable}">{{ validation.type.keyName }}</label></div>
            <div class="ui-grid-col-8">
                <p-dropdown formControlName="type" [style]="{'width':'100%'}"
                            [options]="applicationDropdown"></p-dropdown>
                <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [(form)]="addRoleForm" [validation]="validation.type"></app-validation-msg>
            </div>
        </div>
        <div class="ui-grid-row bottom-10-margin">
        </div>
    </div>
    <p-footer>
        <div class="ui-dialog-buttonpane text-center ui-helper-clearfix">
            <button class="k-generic-btn" type="submit" pButton icon="fa fa-check" [label]="labelButton | translate"></button>
        </div>
    </p-footer>
</form>



// WEBPACK FOOTER //
// ./src/app/views/administration/rolesApplication/rolesApplicationForm.component.html